import { Button } from "antd";
import { CloseCircleFilled } from '@ant-design/icons';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useClient } from "../../context/ClientContext";
import { getContrastColor } from "../../utils/colorContrast";

export const PedidoFallido = () => {
  const navigate = useNavigate();
  const { clientId, theme , clientPath} = useClient();
  const [params] = useSearchParams();
  const pedidoId = params.get("external_reference");
  const primaryColor = theme?.primaryColor || '#ef4444';
  const primaryTextColor = getContrastColor(primaryColor);

  return (
    <div style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
      <div style={{ textAlign: "center", maxWidth: 480 }}>
        <CloseCircleFilled style={{ fontSize: 100, color: "#ef4444" }} />
        <h1 style={{ fontWeight: 700, marginTop: 16, marginBottom: 8 }}>El pago no se completó</h1>
        <p style={{ fontSize: 16, color: "#666", marginBottom: pedidoId ? 12 : 28 }}>
          Hubo un problema con tu pago. Podés reintentar o elegir otro método.
        </p>
        {pedidoId && <p style={{ fontSize: 14, color: "#999", marginBottom: 28 }}>Pedido #{pedidoId}</p>}
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <Button onClick={() => navigate(clientPath('/carrito'))} style={{ fontWeight: 600, borderRadius: 8 }}>
            Volver al carrito
          </Button>
          <Button
            type="primary"
            onClick={() => navigate(clientPath('/mis-pedidos'))}
            style={{ backgroundColor: primaryColor, borderColor: primaryColor, color: primaryTextColor, fontWeight: 700, borderRadius: 8 }}
          >
            Mis pedidos
          </Button>
        </div>
      </div>
    </div>
  );
};
